import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Total market size',
});
